import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import type GlobalStore from "@/store";
import { ShipValidationResult, ShipValidationRule, ShipValidationRuleKey } from "../type";
import { buildValidationFailedResult, buildValidationSuccessfulResult } from "../util";
import ShopDTO from "@/dto/shop/ShopDTO";
import { checkShopIdsEnabledAutoPrint } from "@/scenes/more/AutoPrint/services";

export default async function validateAutoPrint(
    orders: OrderDTO[],
    rule: ShipValidationRule,
    globalStore: typeof GlobalStore,
): Promise<ShipValidationResult> {
    if (!rule[ShipValidationRuleKey.checkAutoPrint]) return buildValidationSuccessfulResult(orders);

    const isSingleOrder = orders.length === 1;
    const shops = [...new Set<ShopDTO>(orders.map((o) => globalStore.shopMapping.get(o.shopId)))];
    const next = await checkShopIdsEnabledAutoPrint(shops, isSingleOrder);

    return next ? buildValidationSuccessfulResult(orders) : buildValidationFailedResult();
}
